import { useMemo } from 'react';

import { LoadingView } from '../../../components/LoadingView';
import { SELECTED_TECH_CATEGORIES } from '../../../domain/user';
import { useTechnologiesQuery } from '../../../features/technologies/useTechnologiesQuery';
import { useUserSettings } from '../../../features/user/useUserSettings';
import { StyledSectionView } from '../styles';

import { TechCategoriesFilter } from './TechCategoriesFilter';
import { TechnologiesHeader } from './TechnologiesHeader';
import { TechnologiesTable } from './TechnologiesTable';

export const Technologies = () => {
  const { getUserSetting } = useUserSettings();
  const appliedCategoriesFromSettings = getUserSetting(SELECTED_TECH_CATEGORIES);
  const appliedCategories = useMemo(
    () => (Array.isArray(appliedCategoriesFromSettings) ? appliedCategoriesFromSettings : []),
    [appliedCategoriesFromSettings]
  );

  const { data, isLoading } = useTechnologiesQuery();

  const filteredTechnologies = useMemo(() => {
    if (!data) {
      return [];
    }
    if (appliedCategories.length === 0) {
      return data;
    }
    return data.filter((technology) => appliedCategories.includes(technology.subCategory));
  }, [data, appliedCategories]);

  return (
    <StyledSectionView data-automation="TechnographicsSection">
      <TechnologiesHeader />
      {isLoading ? (
        <LoadingView />
      ) : (
        <>
          <TechCategoriesFilter
            isDisabled={data?.length === 0}
            technologies={data}
            appliedCategories={appliedCategories}
          />
          <TechnologiesTable technologies={data} filteredTechnologies={filteredTechnologies} />
        </>
      )}
    </StyledSectionView>
  );
};
